<template>
<span class="value-show">{{fullname}}</span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    fullname(){
      return (this.item.firstname + ' ' + this.item.lastname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValueFullname.vue?727024d0